import { z } from 'zod';

import { ProbationReviewCompletionMethod } from '@/common/graphql';

/** The two ways HR can close a review that was not submitted in MED (FR-026); there is no default, HR must choose. */
export const MARK_COMPLETE_METHODS = [
  ProbationReviewCompletionMethod.CompletedOffline,
  ProbationReviewCompletionMethod.LegacyRecord,
] as const;

const REQUIRED_MESSAGE = 'Select how the reviews were completed';

export const ProbationReviewMarkCompleteFormData = z.object({
  completionMethod: z
    .enum(MARK_COMPLETE_METHODS)
    .nullable()
    .default(null)
    .refine(value => value !== null, { message: REQUIRED_MESSAGE }),
});
export type ProbationReviewMarkCompleteFormDataType = z.infer<typeof ProbationReviewMarkCompleteFormData>;
